import { Button } from "@mui/material";
import "./bottom-bar.component.css";

import ShareIcon from "@mui/icons-material/Share";
import ThumbDownIcon from "@mui/icons-material/ThumbDown";
import ThumbUpIcon from "@mui/icons-material/ThumbUp";
import { PostData, PostEvent } from "../post.models";

export interface PostBottomBarProps extends PostData {
  onLikeClicked: PostEvent;
  onDislikeClicked: PostEvent;
  onShareClicked: PostEvent;
  userLiked: boolean;
  userDisliked: boolean;
  userShared: boolean;
  likes: number;
  dislikes: number;
  shares: number;
}

export function PostBottomBar(props: PostBottomBarProps) {
  let likeButtonColor = "primary.main";
  let dislikeButtonColor = "secondary.main";
  let shareButtonColor = "success.main";

  if (props.userLiked) {
    likeButtonColor = "primary.light";
  }

  if (props.userDisliked) {
    dislikeButtonColor = "secondary.light";
  }

  if (props.userShared) {
    shareButtonColor = "success.light";
  }

  return (
    <div
      className="bottom-bar-container"
      id={`${props.id}-bottom-bar-container`}
    >
      <Button
        variant="contained"
        startIcon={<ThumbUpIcon id={`${props.id}-like-button`} />}
        onClick={() => props.onLikeClicked(props)}
        sx={{ bgcolor: likeButtonColor, flex: 1 }}
        id={`${props.id}-like-button`}
      >
        {props.likes}
      </Button>
      <Button
        variant="contained"
        startIcon={<ThumbDownIcon id={`${props.id}-dislike-button`} />}
        onClick={() => props.onDislikeClicked(props)}
        sx={{ bgcolor: dislikeButtonColor, flex: 1 }}
        id={`${props.id}-dislike-button`}
      >
        {props.dislikes}
      </Button>
      <Button
        variant="contained"
        startIcon={<ShareIcon id={`${props.id}-share-button`} />}
        onClick={() => props.onShareClicked(props)}
        sx={{ bgcolor: shareButtonColor, flex: 1 }}
        id={`${props.id}-share-button`}
      >
        {props.shares}
      </Button>
    </div>
  );
}
